export default () => ({
  width: [],
  height: [],
  rims: [],
  motoWidth: [],
  motoHeight: [],
  motoRim: [],
  valueWidth: 225,
  valueHeight: 65,
  valueRim: 17
})
